import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Notification, Search, Typography } from '@telus-uds/components-web';
import { Table, Tbody, Tr, Td } from 'react-super-responsive-table';
 
import request from  '../../../utils/request';
import { useLocaleContext } from  '../../../context/LocaleContext';
 
import { SearchWrapper, TableWrapper, OnBehalfOfBox } from './fields/css';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';
import FieldGuide from '../../../form/fields/common/fieldGuide';
 
const EditableSalesRepInfo = () => {
  const locale = useLocaleContext();
  const {
    USERS: {
      LIST: { searchLabelTitle, searchHintTitle }
    },
    editableSalesRepInfo: {
      selectLabel,
      enterUserError,
      noRecordFoundError,
      toolTip
    }
  } = locale === 'en-US' ? EN : FR;
 
  const [querySrting, setQueryString] = useState();
  const [userList, setUserList] = useState([]);
  const [userSelected, setUserSelected] = useState();
  const [errorMessage, setErrorMessage] = useState();
 
  useEffect(() => {
    localStorage.removeItem('salesRepInfoForSRT');
    return () => {
    //   localStorage.removeItem('salesRepInfoForSRT');
    };
  }, []);
 
  const clearSearch = () => {
    setQueryString('');
    setUserList([]);
  };
 
  const onUserSelect = userInfo => {
    setUserSelected(userInfo);
    localStorage.setItem('salesRepInfoForSRT', JSON.stringify(userInfo));
    clearSearch();
  };
 
  const onUnSelectUser = (e) => {
    if (e && typeof e.stopPropagation === 'function') {
      e.stopPropagation();
      e.preventDefault();
    }
    localStorage.removeItem('salesRepInfoForSRT');
    setUserSelected();
    setUserList([]);
    setQueryString('');
    setErrorMessage('');
  };
 
  const setQuery = e => {
    setQueryString(e.target.value);
  };
 
  const getUsers = (searchQuery) => {
    const q = searchQuery !== undefined ? searchQuery : querySrting;
    if (!q || (typeof q === 'string' && !q.trim())) {
      setErrorMessage(enterUserError);
      setUserList([]);
      return;
    }

    request.get(`/users/for-srt-group?q=${encodeURIComponent(q)}`).then(response => {
      const responseData = response.data.users;
      if (responseData.length === 0) {
        setErrorMessage(noRecordFoundError);
        return;
      }
      const users = response.data.users.map(user => {
        return {
          ...user,
          name: `${user.firstName} ${user.lastName}`,
          channelName: _.get(user, 'channels.0.name', '')
        };
      });
      setUserList(users);
      setErrorMessage('');
    });
  };
 
  return (
    <>
      <OnBehalfOfBox>
        <SearchWrapper>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <div>
              <div style={{ fontSize: '14px', fontWeight: '700' }}>
                <Typography block>{searchLabelTitle}</Typography>
              </div>
              <div style={{ fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '0.25rem' }}>
                <Typography block>{searchHintTitle}</Typography>
                <FieldGuide tooltip={toolTip} />
              </div>
            </div>
          </div>
          <div style={{ marginTop: '0.5rem', minWidth: '500px', maxWidth: '700px' }}>
            <Search
              value={querySrting ?? ''}
              onChange={(val) => setQueryString(val)}
              onSubmit={(val) => getUsers(val)}
              onClear={() => {
                setQueryString('');
                setUserList([]);
                setErrorMessage('');
              }}
              placeholder={searchHintTitle}
              accessibilityLabel={searchLabelTitle}
              copy={locale === 'en-US' ? 'en' : 'fr'}
            />
          </div>
        </div>
      </SearchWrapper>
      {errorMessage && (
        <div style={{ width: 'fit-content', marginTop: '0.5rem' }}>
          <Notification variant={{ validation: 'error' }} copy="en">
            {errorMessage}
          </Notification>
        </div>
      )}
      {!errorMessage && userList.length > 0 && (
        <TableWrapper>
          <Table>
            <Tbody>
              {userList.map((user, index) => (
                <Tr
                  key={user.id}
                  style={{
                    background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                  }}
                >
                  <Td><Typography>{user.name}</Typography></Td>
                  <Td><Typography>{user.email}</Typography></Td>
                  <Td>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => onUserSelect(user)}
                    >
                      <Typography>{selectLabel}</Typography>
                    </button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableWrapper>
      )}
      {userList.length === 0 && userSelected && (
        <div style={{ width: 'fit-content', marginTop: '0.5rem' }}>
          <Notification
            copy="en"
            dismissible
            onDismiss={onUnSelectUser}
          >
            <Typography>Order will be created on behalf of </Typography>
            <Typography variant={{ bold: true }}>{userSelected.name}</Typography>
          </Notification>
        </div>
      )}
      </OnBehalfOfBox>
    </>
  );
};
 
export default EditableSalesRepInfo;